const SearchHelper = {
  search(searchString, array, fieldsArray, optionalRowConverter = (e) => e) {
    return array.filter((row) => {
      let conv = optionalRowConverter(row);
      return searchString
        .split(' ')
        .every((searchPartial) =>
          fieldsArray.some(
            (columnName) =>
              conv[columnName] &&
              conv[columnName]?.toString?.()?.toLowerCase?.()?.includes?.(searchPartial?.toLowerCase?.())
          )
        );
    });
  },
};

export default SearchHelper;
